import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentClinicId } from "@/hooks/useAppointments";

export interface HeatmapCell {
  day_of_week: number;
  shift: "morning" | "afternoon" | "night";
  count: number;
}

export function useReportsHeatmap(dateFrom: Date | null, dateTo: Date | null) {
  const { data: clinicId } = useCurrentClinicId();

  return useQuery({
    queryKey: ["reports-heatmap", clinicId, dateFrom?.toISOString(), dateTo?.toISOString()],
    queryFn: async (): Promise<HeatmapCell[]> => {
      if (!clinicId || !dateFrom || !dateTo) return [];

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any).rpc("get_appointment_heatmap", {
        p_clinic_id: clinicId,
        p_date_from: dateFrom.toISOString(),
        p_date_to: dateTo.toISOString(),
      });

      if (error) throw error;
      return (data ?? []) as HeatmapCell[];
    },
    enabled: !!clinicId && !!dateFrom && !!dateTo,
  });
}
